import { Link } from "react-router-dom";

export const Logo = ({ to = "/", compact = false, testid = "brand-logo" }) => (
  <Link to={to} data-testid={testid} className="flex items-center gap-2.5">
    <img src="/logo-icon.png" alt="Logidem" className="h-8 w-auto" />
    {!compact && (
      <span className="font-display text-xl font-extrabold tracking-tight">
        <span className="text-[#0b2c6b]">LOGI</span>
        <span className="brand-text">DEM</span>
      </span>
    )}
  </Link>
);

export const StatusBadge = ({ map, value, testid }) => {
  const s = map[value] || { label: value, cls: "bg-slate-100 text-slate-700" };
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const PageHeader = ({ overline, title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      {overline && <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-teal-600">{overline}</p>}
      <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, text, testid }) => (
  <div data-testid={testid} className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-16 text-center">
    {Icon && <Icon className="mb-3 h-8 w-8 text-slate-400" />}
    <p className="text-sm text-slate-500">{text}</p>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-semibold text-slate-600">{label}</span>
    {children}
  </label>
);
